<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Sujet</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="row">
        <div class="col border-white">
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Numéro de fiche:</label>
            </div>
            <div class="col txt">
              <a class="hyperlink" @click="consulterSujet()">{{ sujet.numeroFiche }}</a>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Nom:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.nom || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Prénom:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.prenom || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Alias:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.alias || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Date de naissance:</label>
            </div>
            <div class="col txt">
              <p> {{ this.$commun.formatDate(sujet.naissanceDate) || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Sexe:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.sexeAfficher || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Langue:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.langueAfficher || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Ethnie:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.ethnieAfficher || PLACEHOLDER }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 lbl left">
              <label>Teint:</label>
            </div>
            <div class="col txt">
              <p> {{ sujet.teintAfficher || PLACEHOLDER }} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row border-white">
        <div class="col-lg-5 lbl left">
          <label>Caractéristiques:</label>
        </div>
        <div class="col-lg-8 text-left txt">
          <p v-if="!sujet.caracteristiquesAfficher"> ... </p>
          <span v-for="currentCaracteristique in sujet.caracteristiquesAfficher"
                :key="currentCaracteristique.cle">{{ currentCaracteristique }}
                <br>
                </span>
        </div>
      </div>
      <div class="row border-white">
        <div class="col-lg-5 lbl left">
          <label>Jeux:</label>
        </div>
        <div class="col-lg-8 text-left txt">
          <p v-if="!jeuxLiesAfficher"> ... </p>
          <span v-for="currentJeu in [...new Set(jeuxLiesAfficher)]"
              :key="currentJeu">{{ currentJeu }}
            <br>
          </span>
        </div>
      </div>
    </div>
    <div class="col-8">
      <Carousel :value="photosLiees" :numVisible="1" :numScroll="1">
        <template #item="slotProps">
          <div class="border-1 surface-border border-round m-2 text-center py-5 px-3">
            <div class="mb-3">
              <img
                  :src="slotProps.data.src"
                  :alt="slotProps.data.description"
                  class="w-6 shadow-2 carousel-image-dimensions"
              />
            </div>
          </div>
        </template>
      </Carousel>
    </div>
  </div>
  <div v-if="accesPhotosDossier" class="row">
    <DossierLiaisons @dossiers="dossiersRecus"/>
  </div>
  <div class="row">
    <div class="col-10"/>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
import DossierLiaisons from '../../components/galerie/LiaisonsDossier.vue'

export default {
  components: {
    DossierLiaisons
  },
  created() {
    this.PLACEHOLDER = "..."
    this.BASE64_MAGIC = "data:image/jpg;base64,"
  },
  data() {
    return {
      sujet: {},
      photosLiees: [],
      jeuxLiesAfficher: []
    }
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter Sujet Galerie");
    this.$store
        .dispatch("sujet/consulterAction", {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        })
        .then((res) => {
          this.sujet = res.data.entite;
        });
    this.$store
        .dispatch("multimedia/obtenirLiaisonsMultimediaAction", {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
          genre: 'SU'
        })
        .then((res) => {
          this.photosLiees = res.data.entites.filter(mm => (mm.type == 389 || mm.type == 388));
          this.photosLiees.forEach((elem) => {
            elem.src = this.BASE64_MAGIC + elem.donnees
          })
        });

  },
  methods: {
    consulterSujet() {
      this.$router.push({
        name: "sujetConsulter",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    dossiersRecus(dossiers) {
      dossiers.forEach(dossier => {
        this.$store
          .dispatch("jeux/obtenirLiaisonsJeuxAction", {
            cleSource: dossier.destinationEntite.cle,
            siteSource: dossier.destinationEntite.site
          })
          .then((res) => {
            res.data.entite.liste.forEach(liste => {
              this.jeuxLiesAfficher.push(liste.jeuxAfficher);
            });
        });
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      accesPhotosDossier: 'galerie/accesPhotosDossier'
    })
  },
}

</script>
